import Registration from "../../../../jsx/pages/Connector/Registration";

const LoginWrapper = function (props) {
  return <Registration />;
};

export default constore(LoginWrapper);
